import React, { useEffect, useRef, useState } from 'react';
import { ICON } from '../../icons/iconIds';
import IconButton from '../icons/IconButton';
import Card from '../ui/Card';
import Spinner from '../ui/Spinner';
import { documentDesignService } from '../../services/documentDesignService';

const dpiClass = (dpi) => (!dpi ? 'unknown' : dpi >= 300 ? 'good' : dpi >= 200 ? 'fair' : 'low');

const PhotoPicker = ({ documentId, versionNo, slot, onClose, onPick }) => {
  const [q, setQ] = useState('');
  const [query, setQuery] = useState('');
  const [includeUnapproved, setIncludeUnapproved] = useState(false);
  const [items, setItems] = useState(null);
  const [error, setError] = useState(null);
  const seq = useRef(0);

  useEffect(() => {
    const h = setTimeout(() => setQuery(q.trim()), 400);
    return () => clearTimeout(h);
  }, [q]);

  useEffect(() => {
    const mine = ++seq.current;
    setItems(null);
    documentDesignService
      .getPhotoCandidates(documentId, {
        slot: slot.slot_key, q: query || undefined, include_unapproved: includeUnapproved, version: versionNo || undefined,
      })
      .then((data) => mine === seq.current && setItems(data))
      .catch((err) => mine === seq.current && setError(err.message));
  }, [documentId, versionNo, slot.slot_key, query, includeUnapproved]);

  return (
    <div className="dd-modal-overlay" onClick={onClose} role="presentation">
      <div onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Choose photo">
        <Card className="dd-modal dd-picker">
          <div className="dd-detail-header">
            <h3>{slot.kind === 'cover' ? 'Cover photo' : `Opener: ${slot.label}`}</h3>
            <IconButton icon={ICON.ddClose} onClick={onClose} ariaLabel="Close" />
          </div>
          <div className="dd-toolbar">
            <input type="search" className="dd-search" placeholder="Describe the photo you want, or leave empty for best matches"
              value={q} onChange={(e) => setQ(e.target.value)} autoFocus />
            <label className="dd-inline-check">
              <input type="checkbox" checked={includeUnapproved} onChange={(e) => setIncludeUnapproved(e.target.checked)} />
              Include not-yet-approved
            </label>
          </div>
          {error && <div className="dd-error-inline">{error}</div>}
          {!items ? (
            <div className="loading-container"><Spinner size="large" /></div>
          ) : items.length === 0 ? (
            <div className="no-data"><h3>No suitable photos</h3><p>Photos must be at least 1275 px wide and free of safety or consent flags.</p></div>
          ) : (
            <div className="dd-media-grid dd-picker-grid">
              {items.map((p) => (
                <button key={p.media_asset_id} type="button" className="dd-media-card" onClick={() => onPick(p.media_asset_id)}
                  title={p.description || p.file_name}>
                  <div className="dd-media-thumb">
                    {p.thumb_url ? <img src={p.thumb_url} alt={p.file_name} loading="lazy" /> : <span>No preview</span>}
                    <div className="dd-media-badges">
                      <span className={`dd-badge dpi-${dpiClass(p.slot_dpi)}`}>{p.slot_dpi} dpi</span>
                      {!p.approved_external && <span className="dd-badge flagged">Not approved</span>}
                      {p.score != null && <span className="dd-badge muted">{Math.round(p.score * 100)}% match</span>}
                    </div>
                  </div>
                  <div className="dd-media-meta">
                    <span className="dd-media-name">{p.file_name}</span>
                    <span className="dd-media-sub">{p.width_px}×{p.height_px}{p.photo_credit ? ` · ${p.photo_credit}` : ''}</span>
                  </div>
                </button>
              ))}
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};

export default PhotoPicker;
